import { ManualCodeEntry } from '@/components/manual-code-entry/component';
import { Scanner } from '@/components/scanner';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { Button, Flex } from '@mantine/core';
import { useState } from 'react';
import { useBaleInboundContext } from '../hook';

export const ReceivingScanAddPage = () => {
	const { setPage, handleReceivingBaleScan, manualCodeEntryOpen, setManualCodeEntryOpen } =
		useBaleInboundContext();
	const [code, setCode] = useState('');

	const handleBack = () => {
		setPage('RECEIVING');
	};

	return (
		<MobileContainer header={<MobileHeader title="Confirm Bales" onBack={handleBack} />}>
			<Scanner onScan={(code) => handleReceivingBaleScan('ADD', code)} />
			<ManualCodeEntry
				value={code}
				setValue={setCode}
				open={manualCodeEntryOpen}
				instructions="Please enter the code found on the bale tag to confirm receipt."
				onClose={() => setManualCodeEntryOpen(false)}
				shouldValidate
				actions={({ isValid, onClose }) => {
					return (
						<Flex gap="sm">
							<Button
								variant="filled"
								fullWidth
								onClick={() => {
									onClose();
									setCode('');
								}}
							>
								Cancel
							</Button>
							<Button
								variant="filled"
								fullWidth
								onClick={() => handleReceivingBaleScan('ADD', code).then(() => onClose())}
								disabled={!isValid}
							>
								Confirm Bale
							</Button>
						</Flex>
					);
				}}
			/>
		</MobileContainer>
	);
};
